// Label.js

export const Label = ({ className, ...props }) => (
  <div className={`${className || ""}`} {...props} />
);
